export default {
  badge: 'نشان',
  open: 'باز کردن',
  close: 'بستن',
  dismiss: 'رد کردن',
  confirmEdit: {
    ok: 'تایید',
    cancel: 'لغو',
  },
  dataIterator: {
    noResultsText: 'نتیجه‌ای یافت نشد',
    loadingText: 'در حال بارگذاری...',
  },
  dataTable: {
    itemsPerPageText: 'ردیف در صفحه:',
    ariaLabel: {
      sortDescending: 'مرتب‌سازی نزولی',
      sortAscending: 'مرتب‌سازی صعودی',
      sortNone: 'بدون مرتب‌سازی',
      activateNone: 'غیرفعال‌سازی مرتب‌سازی',
      activateDescending: 'غیرفعال‌سازی مرتب‌سازی نزولی',
      activateAscending: 'غیرفعال‌سازی مرتب‌سازی صعودی',
    },
    sortBy: 'مرتب‌سازی براساس',
  },
  dataFooter: {
    itemsPerPageText: 'ردیف در صفحه:',
    itemsPerPageAll: 'همه',
    nextPage: 'صفحه‌ی بعد',
    prevPage: 'صفحه‌ی قبل',
    firstPage: 'صفحه‌ی یکم',
    lastPage: 'صفحه‌ی آخر',
    pageText: '{0} تا {1} از {2}',
  },
  dateRangeInput: {
    divider: 'تا',
  },
  datePicker: {
    itemsSelected: '{0} انتخاب‌شده',
    range: {
      title: 'انتخاب تاریخ‌ها',
      header: 'تاریخ‌ها را وارد کنید',
    },
    title: 'انتخاب تاریخ',
    header: 'تاریخ را وارد کنید',
    input: {
      placeholder: 'تاریخ را وارد کنید',
    },
  },
  noDataText: 'داده‌ای موجود نیست',
  carousel: {
    prev: 'اسلاید قبلی',
    next: 'اسلاید بعدی',
    ariaLabel: {
      delimiter: 'اسلاید {0} از {1}',
    },
  },
  calendar: {
    moreEvents: '{بیشتر {0',
    today: 'امروز',
  },
  input: {
    clear: 'پاکسازی {0}',
    prependAction: '{0} اقدام پیشین',
    appendAction: '{0} اقدام افزوده‌شده',
    otp: 'لطفا کد را وارد کنید {0}',
  },
  fileInput: {
    counter: '{0} پرونده',
    counterSize: '{0} پرونده ({1} در کل)',
  },
  fileUpload: {
    title: 'فایل‌ها را اینجا بکشید و رها کنید',
    divider: 'یا',
    browse: 'مرور فایل‌ها',
  },
  timePicker: {
    am: 'قبل از ظهر',
    pm: 'بعد از ظهر',
    title: 'انتخاب زمان',
  },
  pagination: {
    ariaLabel: {
      root: 'جهت یابی صفحه',
      next: 'صفحه‌ی بعد',
      previous: 'صفحه‌ی قبلی',
      page: 'برو صفحه {0}',
      currentPage: '{0} صفحه‌ی فعلی ، صفحه‌ی',
      first: 'صفحه‌ی اول',
      last: 'صفحه‌ی آخر',
    },
  },
  stepper: {
    next: 'بعدی',
    prev: 'قبلی',
  },
  rating: {
    ariaLabel: {
      item: 'امتیاز {0} از {1}',
    },
  },
  loading: 'در حال بارگذاری...',
  infiniteScroll: {
    loadMore: 'بارگذاری بیشتر',
    empty: 'پایان',
  },
  rules: {
    required: 'این فیلد الزامی است',
    email: 'لطفاً یک ایمیل معتبر وارد کنید',
    number: 'این فیلد فقط می‌تواند شامل اعداد باشد',
    integer: 'این فیلد فقط می‌تواند شامل اعداد صحیح باشد',
    capital: 'این فیلد فقط می‌تواند شامل حروف بزرگ باشد',
    maxLength: 'حداکثر باید {0} کاراکتر وارد کنید',
    minLength: 'حداقل باید {0} کاراکتر وارد کنید',
    strictLength: 'طول فیلد وارد شده نامعتبر است',
    exclude: 'کاراکتر {0} مجاز نیست',
    notEmpty: 'لطفاً حداقل یک مقدار انتخاب کنید',
    pattern: 'فرمت نامعتبر',
  },
}
